// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"677":"4ccc7611","873":"b1bc38b7"}[chunkId] + ".js";
};